// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as chatLayoutRouteImport } from './routes/(chat)/layout'
import { Route as publicLayoutRouteImport } from './routes/(public)/layout'
import { Route as showcaseLayoutRouteImport } from './routes/(showcase)/layout'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as publicAboutRouteImport } from './routes/(public)/about'
import { Route as publicBrandRouteImport } from './routes/(public)/brand'
import { Route as publicContactRouteImport } from './routes/(public)/contact'
import { Route as publicFaqRouteImport } from './routes/(public)/faq'
import { Route as publicHowWeWorkRouteImport } from './routes/(public)/how-we-work'
import { Route as publicLegalRouteImport } from './routes/(public)/legal'
import { Route as publicPrivacyPolicyRouteImport } from './routes/(public)/privacy-policy'
import { Route as publicTermsOfServiceRouteImport } from './routes/(public)/terms-of-service'
import { Route as chatChatIndexRouteImport } from './routes/(chat)/chat/index'
import { Route as publicBlogIndexRouteImport } from './routes/(public)/blog/index'
import { Route as publicBlogArticleIdRouteImport } from './routes/(public)/blog/$articleId'
import { Route as publicPainPointsIndexRouteImport } from './routes/(public)/pain-points/index'
import { Route as publicProjectsIndexRouteImport } from './routes/(public)/projects/index'
import { Route as publicProjectsProjectIdRouteImport } from './routes/(public)/projects/$projectId'
import { Route as publicServicesIndexRouteImport } from './routes/(public)/services/index'
import { Route as publicServicesServiceSlugRouteImport } from './routes/(public)/services/$serviceSlug'
import { Route as showcaseShowcaseIndexRouteImport } from './routes/(showcase)/showcase/index'
import { Route as showcaseShowcaseBookingRouteImport } from './routes/(showcase)/showcase/booking'
import { Route as showcaseShowcaseConciergeRouteImport } from './routes/(showcase)/showcase/concierge'
import { Route as showcaseShowcaseGalleryRouteImport } from './routes/(showcase)/showcase/gallery'
import { Route as showcaseShowcaseNeighborhoodRouteImport } from './routes/(showcase)/showcase/neighborhood'
import { Route as showcaseShowcaseOperatorRouteImport } from './routes/(showcase)/showcase/operator'
import { Route as showcaseShowcaseReviewsRouteImport } from './routes/(showcase)/showcase/reviews'
import { Route as publicBlogPreviewTokenRouteImport } from './routes/(public)/blog/preview.$token'
import { Route as publicProjectsPreviewTokenRouteImport } from './routes/(public)/projects/preview.$token'
import { Route as showcaseShowcaseBookingConfirmedBookingIdRouteImport } from './routes/(showcase)/showcase/booking_.confirmed.$bookingId'

const chatLayoutRoute = chatLayoutRouteImport.update({
            id: '/(chat)',getParentRoute: () => rootRouteImport
          })
const publicLayoutRoute = publicLayoutRouteImport.update({
            id: '/(public)',getParentRoute: () => rootRouteImport
          })
const showcaseLayoutRoute = showcaseLayoutRouteImport.update({
            id: '/(showcase)',getParentRoute: () => rootRouteImport
          })
const publicIndexRoute = publicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => publicLayoutRoute
          })
const publicAboutRoute = publicAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => publicLayoutRoute
          })
const publicBrandRoute = publicBrandRouteImport.update({
            id: '/brand',path: '/brand',getParentRoute: () => publicLayoutRoute
          })
const publicContactRoute = publicContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => publicLayoutRoute
          })
const publicFaqRoute = publicFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => publicLayoutRoute
          })
const publicHowWeWorkRoute = publicHowWeWorkRouteImport.update({
            id: '/how-we-work',path: '/how-we-work',getParentRoute: () => publicLayoutRoute
          })
const publicLegalRoute = publicLegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => publicLayoutRoute
          })
const publicPrivacyPolicyRoute = publicPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => publicLayoutRoute
          })
const publicTermsOfServiceRoute = publicTermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => publicLayoutRoute
          })
const chatChatIndexRoute = chatChatIndexRouteImport.update({
            id: '/chat/',path: '/chat/',getParentRoute: () => chatLayoutRoute
          })
const publicBlogIndexRoute = publicBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => publicLayoutRoute
          })
const publicBlogArticleIdRoute = publicBlogArticleIdRouteImport.update({
            id: '/blog/$articleId',path: '/blog/$articleId',getParentRoute: () => publicLayoutRoute
          })
const publicPainPointsIndexRoute = publicPainPointsIndexRouteImport.update({
            id: '/pain-points/',path: '/pain-points/',getParentRoute: () => publicLayoutRoute
          })
const publicProjectsIndexRoute = publicProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => publicLayoutRoute
          })
const publicProjectsProjectIdRoute = publicProjectsProjectIdRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => publicLayoutRoute
          })
const publicServicesIndexRoute = publicServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => publicLayoutRoute
          })
const publicServicesServiceSlugRoute = publicServicesServiceSlugRouteImport.update({
            id: '/services/$serviceSlug',path: '/services/$serviceSlug',getParentRoute: () => publicLayoutRoute
          })
const showcaseShowcaseIndexRoute = showcaseShowcaseIndexRouteImport.update({
            id: '/showcase/',path: '/showcase/',getParentRoute: () => showcaseLayoutRoute
          })
const showcaseShowcaseBookingRoute = showcaseShowcaseBookingRouteImport.update({
            id: '/showcase/booking',path: '/showcase/booking',getParentRoute: () => showcaseLayoutRoute
          })
const showcaseShowcaseConciergeRoute = showcaseShowcaseConciergeRouteImport.update({
            id: '/showcase/concierge',path: '/showcase/concierge',getParentRoute: () => showcaseLayoutRoute
          })
const showcaseShowcaseGalleryRoute = showcaseShowcaseGalleryRouteImport.update({
            id: '/showcase/gallery',path: '/showcase/gallery',getParentRoute: () => showcaseLayoutRoute
          })
const showcaseShowcaseNeighborhoodRoute = showcaseShowcaseNeighborhoodRouteImport.update({
            id: '/showcase/neighborhood',path: '/showcase/neighborhood',getParentRoute: () => showcaseLayoutRoute
          })
const showcaseShowcaseOperatorRoute = showcaseShowcaseOperatorRouteImport.update({
            id: '/showcase/operator',path: '/showcase/operator',getParentRoute: () => showcaseLayoutRoute
          })
const showcaseShowcaseReviewsRoute = showcaseShowcaseReviewsRouteImport.update({
            id: '/showcase/reviews',path: '/showcase/reviews',getParentRoute: () => showcaseLayoutRoute
          })
const publicBlogPreviewTokenRoute = publicBlogPreviewTokenRouteImport.update({
            id: '/blog/preview/$token',path: '/blog/preview/$token',getParentRoute: () => publicLayoutRoute
          })
const publicProjectsPreviewTokenRoute = publicProjectsPreviewTokenRouteImport.update({
            id: '/projects/preview/$token',path: '/projects/preview/$token',getParentRoute: () => publicLayoutRoute
          })
const showcaseShowcaseBookingConfirmedBookingIdRoute = showcaseShowcaseBookingConfirmedBookingIdRouteImport.update({
            id: '/showcase/booking_/confirmed/$bookingId',path: '/showcase/booking/confirmed/$bookingId',getParentRoute: () => showcaseLayoutRoute
          })





const chatLayoutRouteChildren = {
  chatChatIndexRoute: chatChatIndexRoute
}

const chatLayoutRouteWithChildren = chatLayoutRoute._addFileChildren(chatLayoutRouteChildren)




const publicLayoutRouteChildren = {
  publicAboutRoute: publicAboutRoute,publicBrandRoute: publicBrandRoute,publicContactRoute: publicContactRoute,publicFaqRoute: publicFaqRoute,publicHowWeWorkRoute: publicHowWeWorkRoute,publicLegalRoute: publicLegalRoute,publicPrivacyPolicyRoute: publicPrivacyPolicyRoute,publicTermsOfServiceRoute: publicTermsOfServiceRoute,publicIndexRoute: publicIndexRoute,publicBlogArticleIdRoute: publicBlogArticleIdRoute,publicProjectsProjectIdRoute: publicProjectsProjectIdRoute,publicServicesServiceSlugRoute: publicServicesServiceSlugRoute,publicBlogIndexRoute: publicBlogIndexRoute,publicPainPointsIndexRoute: publicPainPointsIndexRoute,publicProjectsIndexRoute: publicProjectsIndexRoute,publicServicesIndexRoute: publicServicesIndexRoute,publicBlogPreviewTokenRoute: publicBlogPreviewTokenRoute,publicProjectsPreviewTokenRoute: publicProjectsPreviewTokenRoute
}

const publicLayoutRouteWithChildren = publicLayoutRoute._addFileChildren(publicLayoutRouteChildren)




const showcaseLayoutRouteChildren = {
  showcaseShowcaseBookingRoute: showcaseShowcaseBookingRoute,showcaseShowcaseConciergeRoute: showcaseShowcaseConciergeRoute,showcaseShowcaseGalleryRoute: showcaseShowcaseGalleryRoute,showcaseShowcaseNeighborhoodRoute: showcaseShowcaseNeighborhoodRoute,showcaseShowcaseOperatorRoute: showcaseShowcaseOperatorRoute,showcaseShowcaseReviewsRoute: showcaseShowcaseReviewsRoute,showcaseShowcaseIndexRoute: showcaseShowcaseIndexRoute,showcaseShowcaseBookingConfirmedBookingIdRoute: showcaseShowcaseBookingConfirmedBookingIdRoute
}

const showcaseLayoutRouteWithChildren = showcaseLayoutRoute._addFileChildren(showcaseLayoutRouteChildren)

const rootRouteChildren = {
  chatLayoutRoute: chatLayoutRouteWithChildren,publicLayoutRoute: publicLayoutRouteWithChildren,showcaseLayoutRoute: showcaseLayoutRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)